'use client'

import { CircleCheck, CircleX, AlertTriangle } from 'lucide-react'

interface Finding {
  text: string
  status: 'good' | 'warning' | 'bad'
}

interface AeoScoreCardProps {
  title: string
  icon: React.ReactNode
  score: number
  maxScore: number
  findings: Finding[]
  color: string
}

export default function AeoScoreCard({
  title,
  icon,
  score,
  maxScore,
  findings,
  color,
}: AeoScoreCardProps) {
  const pct = maxScore > 0 ? Math.round((score / maxScore) * 100) : 0

  return (
    <div className='bg-background border border-border/60 rounded-2xl p-5 flex flex-col gap-3'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          <span style={{ color }}>{icon}</span>
          <h3 className='text-sm font-semibold text-foreground'>{title}</h3>
        </div>
        <span
          className='text-xs font-bold rounded-full px-2.5 py-0.5'
          style={{ backgroundColor: `${color}15`, color }}
        >
          {score}/{maxScore}
        </span>
      </div>

      <div className='h-2 rounded-full bg-muted overflow-hidden'>
        <div
          className='h-full rounded-full transition-all duration-700 ease-out'
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>

      <ul className='space-y-1'>
        {findings.map((f, i) => (
          <li
            key={i}
            className='text-xs text-foreground/80 flex items-start gap-1.5'
          >
            {f.status === 'good' ? (
              <CircleCheck
                size={14}
                className='mt-0.5 shrink-0'
                style={{ color: '#22c55e' }}
              />
            ) : f.status === 'bad' ? (
              <CircleX
                size={14}
                className='mt-0.5 shrink-0'
                style={{ color: '#F90B8A' }}
              />
            ) : (
              <AlertTriangle
                size={14}
                className='mt-0.5 shrink-0'
                style={{ color: '#FDC304' }}
              />
            )}
            {f.text}
          </li>
        ))}
      </ul>
    </div>
  )
}
